<template>
  <div class="o-wrapper u-margin-bottom">
    <div class="o-layout">
      <div class="o-layout__item u-1/2@lap">
        <div class="c-form__field u-margin-bottom-small">
          <label for="q" class="c-form__label u-h3 u-margin-bottom-tiny">
            Indiquer une ville, un lieu, un code postal
          </label>
          <gmap-autocomplete
            id="q"
            ref="autocomplete"
            class="c-form__input string u-1/1"
            :placeholder="''"
            :componentRestrictions="autocomplete.componentRestrictions"
            :selectFirstOnEnter="autocomplete.selectFirstOnEnter"
            :options="{fields: ['geometry', 'place_id', 'formatted_address']}"
            :value="address"
            v-on:keydown.enter="preventSubmit"
          ></gmap-autocomplete>
        </div>
      </div><!--
      --><div class="o-layout__item u-1/2@lap" v-if="product">
        <div class="c-form__label u-h3 u-margin-bottom-tiny">
          Votre produit
        </div>
        <div class="o-layout">
          <div class="o-layout__item u-1/3">
            <div class="o-ratio o-ratio--1:1 c-product__image-wrapper">
              <div class="o-ratio__content c-product__image">
                <img :src="product.image_url" class="c-product__img">
              </div>
            </div>
          </div><!--
          --><div class="o-layout__item u-2/3">
            <h2 class="u-h4 u-color__green c-product__title">
              {{ product.name }}
            </h2>
            <div v-html="product.post_excerpt"></div>
          </div>
        </div>
        <a
          class="c-store-category__link c-store-category__link--back"
          v-if="location"
          v-on:click="chooseOtherProduct()"
        >
          Choisir un autre produit
        </a>
      </div><!--
      --><div class="o-layout__item u-1/2@lap" v-if="showProductSelector">
          <div class="c-form__label u-h3 u-margin-bottom-tiny">
            Choisir un produit
          </div>
          <ol v-if="isCategorySelected()" class="o-list-inline c-breadcrumbs u-margin-bottom-tiny">
            <li v-for="item in categoryBreadcrumbs" class="o-list-inline__item c-breadcrumbs__item" :key="`item-${item}`">{{ item }}</li>
          </ol>
          <ul class="o-list-bare c-store-categories u-margin-bottom-tiny">
            <li v-for="category in currentCategories" :key="`category-${category.term_id}`">
              <a
                v-on:click="selectCategory(category)"
                class="c-store-category__link"
              >
                {{ category.name }}
              </a>
            </li>
            <li>
              <a
                v-if="isCategorySelected()"
                v-on:click="categoryBack()"
                class="c-store-category__link c-store-category__link--back"
              >
                Retour
              </a>
            </li>
          </ul>
          <div v-if="loadingProducts">
            <p>
              <img src="/wp-content/themes/wp-starter/images/spin.gif" alt="Chargement en cours" style="float:left;">&nbsp;
              Chargement des produits...
            </p>
          </div>
          <div class="c-product-grid c-product-grid--narrow">
            <div
              class="c-product-grid__item"
              v-for="product in products"
              :key="`product-${product.ID}`"
              v-on:click="selectProduct(product)"
            >
              <div class="o-block o-block--flush c-product-summary u-margin-bottom-small">
                <div class="o-block__img">
                  <div class="o-ratio o-ratio--1:1 c-product-summary__image-wrapper">
                    <div class="o-ratio__content o-box o-box--tiny c-product-summary__image">
                      <img :src="product.image_url" class="c-store-product__img">
                    </div>
                  </div>
                </div>
                <div class="o-block__body o-box o-box--tiny c-product-summary__body">
                  <a class="c-product-summary__link">
                    <div class="c-product-summary__title">
                      {{ product.name }}
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'underscore'
  import { mapGetters, mapState } from 'vuex'
  import { loaded } from 'vue2-google-maps'

  export default {
    data: function() {
      return {
        autocomplete: {
          componentRestrictions: {
            country: 'fr',
          },
          selectFirstOnEnter: true,
        },
      }
    },
    mounted: function () {
      this.$refs.autocomplete.$on('place_changed', place => {
        this.$store.dispatch('selectPlace', place)
      })

      loaded.then(() => {
          if (this.address) {
            this.selectFirstPrediction(this.address)
          }
      })
    },
    computed: {
      ...mapGetters([
        'location',
        'product',
        'categories',
        'currentCategory',
        'categoriesStack',
        'products',
        'loadingProducts',
      ]),
      address () {
        if (this.location && this.location.address) {
          return this.location.address
        }
        if (this.location && this.location.q) {
          return this.location.q
        }
        return ''
      },
      currentCategories () {
        if (this.categoriesStack.length === 0) {
          return this.categories
        }
        return _.last(this.categoriesStack).children
      },
      categoryBreadcrumbs () {
        return _.map(this.categoriesStack, function (c) {
          return c.name
        })
      },
      showProductSelector () {
        return this.location && !this.product
      },
    },
    methods: {
      selectFirstPrediction: function (name) {
        var autocompleteService = new google.maps.places.AutocompleteService()
        autocompleteService.getPlacePredictions(Object.assign({input: name}, this.googleMapsOptions), (predictions) => {
          if (predictions === null) {
            return false
          }

          var placeService = new google.maps.places.PlacesService(document.createElement('div'))
          placeService.getDetails({placeId: predictions[0].place_id}, (place) => {
            this.$store.dispatch('selectPlace', place)
          })
        })
      },
      chooseOtherProduct () {
        this.$store.dispatch('chooseOtherProduct')
      },
      selectCategory (category) {
        this.$store.dispatch('navigateInCategory', category)
      },
      selectProduct (product) {
        this.$store.dispatch('selectProduct', product)
      },
      isCategorySelected () {
        return this.categoriesStack.length > 0
      },
      categoryBack () {
        this.$store.dispatch('navigateBackCategories')
      },
    },
  }
</script>

<style scoped>

.c-store-category__link::after {
  color: #7a7576;
  content: " > ";
}
.c-store-category__link--back::before {
  color: #7a7576;
  content: " < ";
}
.c-store-category__link--back::after {
  content: "";
}

a.c-store-category__link,
a.c-store-category__link:active,
a.c-store-category__link:focus,
a.c-store-category__link:hover {
  border: 0;
  color: #575655;
  cursor: pointer;
}
a.c-store-category__link:active,
a.c-store-category__link:focus,
a.c-store-category__link:hover {
  border: 0;
  color: #647636;
}
.c-store-category__link {
  padding-left: 12px;
}
.c-store-category__link--back {
  padding-left: 0;
}

.c-product-summary__title {
  font-size: 12px;
}

</style>
